"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
let obj = {
    matches: ["openView"],
    execute: (commandName, commandOptions) => {
        let viewNameRegex = /^[a-z0-9_]+$/i;
        if (viewNameRegex.test(commandOptions.viewName)) {
            let qs = "";
            if (commandOptions.viewOptions) {
                for (let prop in commandOptions.viewOptions) {
                    if (qs.length === 0)
                        qs += "?";
                    else
                        qs += "&";
                    qs += prop + "=" + encodeURIComponent(commandOptions.viewOptions[prop]);
                }
            }
            const url = tdBasePath + "/#/" + commandOptions.viewName + qs;
            if (commandOptions.sameTab)
                location.assign(url);
            else {
                let wnd = window.open(url, "useCase_" + commandName + "_" + commandOptions.viewName);
                wnd.location.reload();
            }
        }
        return Promise.resolve();
    },
    isBreadcrumbElement: false
};
exports.default = obj;
